import {CHOOSE_SUITABLE_EVENT, SET_EVENT_ID} from "./action";
import {AnyAction} from "redux";



/**
 * choose an event to display at random
 */
export function chooseRelevantEvent() : AnyAction
{
    return {type: CHOOSE_SUITABLE_EVENT};
}


/**
 * display an event
 */
export function setEventID(event_id: string) : AnyAction
{
    return {type: SET_EVENT_ID, payload: {event_id}};
}


// WEBPACK FOOTER //
// ./src/ts/store/actions/events.ts